<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    floating
    class="elevation-0"
    id="appDrawer"
    width="205"
    height="auto"
    :color="$vuetify.theme.dark ? '#121212' : '#ffffff'"
  >
    <v-toolbar
      class="ml-0 pl-3 elevation-0"
      :color="$vuetify.theme.dark ? '#121212' : '#ffffff'"
    >
      <!--<img v-bind:src="computeLogo" height="36" alt="EA">-->
      <img
        :src="
          $vuetify.theme.dark
            ? '/../../img/logo/ls-h-branco.svg'
            : '/../../img/logo/ls-h-azul.svg'
        "
        height="50px"
        style="margin-left: -14px; margin-top: 2px"
        alt="Logo da Lucas Silva Educação"
      />
      <!--<v-icon>ls-logo-white</v-icon>-->
      <v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down"></span>
      </v-toolbar-title>
    </v-toolbar>
    <v-layout fill-height>
      <vue-perfect-scrollbar
        class="drawer-menu--scroll"
        :settings="scrollSettings"
      >
        <v-list expand rounded>
          <template
            v-for="(item, i) in menus.map((item) => {
              if (this.isOffline) {
                if (item.name === 'mocks.search')
                  return { ...item, disabled: true };
                if (item.name === 'mocks') return { ...item, disabled: true };
                if (item.name === 'mocks.logs')
                  return { ...item, disabled: true };
                if (item.name === 'exams') return { ...item, disabled: true };
                if (item.header === 'Treinamento')
                  return { ...item, disabled: true };
                if (item.header === 'Acelerar')
                  return { ...item, disabled: true };
                if (item.name === 'shop') return { ...item, disabled: true };
                if (item.name === 'support') return { ...item, disabled: true };
              }
              return item;
            })"
          >
            <!--group with subitems-->
            <v-list-group
              v-if="item.items"
              :style="!!item.disabled ? 'opacity:0.5;pointer-events:none' : ''"
              :key="item.name"
              :group="item.group"
              :prepend-icon="item.icon"
              no-action="no-action"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title style="font-weight: 400">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group
                  v-if="subItem.items"
                  :key="subItem.name"
                  :group="subItem.group"
                  sub-group="sub-group"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    v-for="(grand, i) in subItem.children"
                    :key="i"
                    :to="genChildTarget(item, grand)"
                    :href="grand.href"
                    ripple="ripple"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ grand.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
                <!--child item-->
                <v-list-item
                  v-else
                  :key="i"
                  :to="genChildTarget(item, subItem)"
                  :href="subItem.href"
                  :disabled="subItem.disabled"
                  :target="subItem.target"
                  ripple="ripple"
                >
                  <v-list-item-content>
                    <v-list-item-title style="font-weight: 400"
                      ><span>{{ subItem.title }}</span></v-list-item-title
                    >
                  </v-list-item-content>
                  <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                  <v-list-item-action v-if="subItem.action">
                    <v-icon :class="[subItem.actionClass || 'success--text']"
                      >{{ subItem.action }}
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list-group>
            <v-subheader
              v-else-if="item.header"
              :key="i"
              style="font-weight: 500"
              >{{ item.header }}</v-subheader
            >
            <v-divider v-else-if="item.divider" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-item
              color="primary"
              v-else
              :to="!item.href ? { name: item.name } : null"
              :href="item.href"
              ripple="ripple"
              :disabled="item.disabled"
              :target="item.target"
              rel="noopener"
              :key="item.name"
            >
              <v-list-item-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title style="font-weight: 400">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item-content>
              <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
              <v-list-item-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-item-action>
              <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
            </v-list-item>
          </template>
        </v-list>
      </vue-perfect-scrollbar>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { getMenu } from "~/api/menu";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "app-drawer",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    mini: false,
    miniBase: false,
    drawer: false,
    menus: [],
    scrollSettings: {
      maxScrollbarLength: 160,
    },
    isOffline: !navigator.onLine,
  }),
  mounted() {
    getMenu().then((menu) => {
      this.menus = menu;
    });
    window.addEventListener("offline", () => {
      console.log("went off");
      this.isOffline = true;
    });
    window.addEventListener("online", () => {
      console.log("went on");
      this.isOffline = false;
    });
    this.drawer = this.$vuetify.breakpoint.xs ? false : true;
  },
  computed: {
    computeGroupActive() {
      return true;
    },
    computeLogo() {
      return "/static/m.png";
    },
    sideToolbarColor() {
      return this.$vuetify.options.extra.sideNav;
    },
  },
  created() {
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.drawer = !this.drawer;
      this.mini = !this.mini;
    });
  },

  methods: {
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      return { name: `${item.group}/${subItem.name}` };
    },
  },
};
</script>

<style lang="scss" scoped>
#appDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 64px);
    width: 100%;
    overflow: auto;
  }
}

.v-list__tile__content {
  &:hover {
    text-decoration: none;
  }
}
</style>
